import Helmet from "react-helmet";
import { Outlet, Route } from "react-router";

import BimClassDetail from "./domain/BimClass/BimClassDetail";
import BimClassNew from "./domain/BimClass/BimClassNew";
import BimClassRedirectToRevision from "./domain/BimClass/RedirectToRevision";
import WithBimClassInventory from "./domain/BimClass/WithBimClassInventory";
import CategoryDetail from "./domain/Category/CategoryDetail";
import CategoryNew from "./domain/Category/CategoryNew";
import WithCategoryInventory from "./domain/Category/WithCategoryInventory";
import GeometryTypeDetail from "./domain/GeometryType/GeometryTypeDetail";
import GeometryTypeNew from "./domain/GeometryType/GeometryTypeNew";
import GeometryTypeRedirectToGeometryType from "./domain/GeometryType/RedirectToGeometryType";
import GeometryTypeRedirectToRevision from "./domain/GeometryType/RedirectToRevision";
import Intro from "./domain/Intro";
import ParameterDetail from "./domain/Parameter/ParameterDetail";
import ParameterNew from "./domain/Parameter/ParameterNew";
import WithParameterInventory from "./domain/Parameter/WithParameterInventory";
import ParameterGroupDetail from "./domain/ParameterGroup/ParameterGroupDetail";
import ParameterGroupNew from "./domain/ParameterGroup/ParameterGroupNew";
import WithParameterGroupInventory from "./domain/ParameterGroup/WithParameterGroupInventory";
import TaxonomyApolloProvider from "./services/Taxonomy/ApolloProvider";
import { NotificationsProvider } from "../../components/Notifications";

function App() {
    return (
        <TaxonomyApolloProvider>
            <NotificationsProvider>
                <Helmet>
                    <title>taxonomy</title>
                </Helmet>
                <Outlet />
            </NotificationsProvider>
        </TaxonomyApolloProvider>
    );
}

export default (
    <Route Component={ App } path="taxonomy">
        <Route Component={ Intro } index />
        <Route Component={ WithBimClassInventory } path="BimClasses">
            <Route Component={ BimClassNew } path="new" />
            <Route path=":bimClassID">
                <Route Component={ BimClassRedirectToRevision } index />
                <Route Component={ BimClassDetail } path="revisions/:bimClassRevisionID" />
                <Route path="GeometryTypes">
                    <Route Component={ GeometryTypeNew } path="new" />
                    <Route path=":geometryTypeID">
                        <Route Component={ GeometryTypeRedirectToRevision } index />
                        <Route Component={ GeometryTypeDetail } path="revisions/:geometryTypeRevisionID" />
                    </Route>
                </Route>
            </Route>
        </Route>
        <Route Component={ WithCategoryInventory } path="Categories">
            <Route Component={ CategoryNew } path="new" />
            <Route Component={ CategoryDetail } path=":categoryID" />
        </Route>
        <Route Component={ GeometryTypeRedirectToGeometryType } path="GeometryTypes/:geometryTypeID" />
        <Route Component={ WithParameterInventory } path="Parameters">
            <Route Component={ ParameterNew } path="new" />
            <Route Component={ ParameterDetail } path=":parameterID" />
        </Route>
        <Route Component={ WithParameterGroupInventory } path="ParameterGroups">
            <Route Component={ ParameterGroupNew } path="new" />
            <Route Component={ ParameterGroupDetail } path=":parameterGroupID" />
        </Route>
    </Route>
);
